<template>
  <div class="d-block px-2 py-3">
    <v-card outlined elevation="0" id="filter-card" class="mb-5 d-none">
      <v-card-text>
        <v-form>
          <v-row>
            <v-col cols="3" class="py-0">
              <v-menu
                ref="menuDate"
                v-model="menuDate"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeText"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                    outlined
                    clearable
                    densed
                    class="datePickerSmall"
                    placeholder="Tgl Transaksi"
                    @click:clear="clearDate"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="filter.dateRange"
                  no-title
                  @click:date="searchTrx"
                  @change="tglTransaksiFilter.value = filter.dateRange"
                >
                </v-date-picker>
              </v-menu>
            </v-col>
            
            <v-col cols="3" class="py-0">
              <v-combobox
                v-model="filter.type"
                dense
                outlined
                item-text="label"
                item-value="value"
                hide-details="auto"
                :items="filterOptions"
              ></v-combobox>
            </v-col>

            <v-col cols="6" class="py-0">
              <v-text-field
                v-model="filter.search"
                outlined
                small
                dense
                clearable
                hide-details="auto"
                class="searchInput"
                @input="buyerNameFilter.value = filter.search, invoiceNoFilter.value = filter.search"
                @click:clear="clearSearch"
                @keyup.enter="searchTrx"
                placeholder="Masukkan kata kunci"
              >
                <div slot="append">
                  <v-btn
                    small
                    elevation="2"
                    color="success"
                    @click="searchTrx"
                  >
                    <v-icon center>
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                </div>
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-layout v-resize="onResize" column>
      <v-data-table
        v-model="selected"
        :server-items-length="pesananNewPagination.total_data"
        :items="listPesanan"
        :loading="loadingList"
        :headers="headers"
        :expanded.sync="expanded"
        :hide-default-header="true"
        :hide-default-footer="true"
        item-key="trx_id"
        show-expand
        single-expand
        class="elevation-1 border"
        :class="{mobile: isMobile}"
        id="order-table"
        @item-expanded="loadDetailPesanan"
      >
        <template v-slot:item.trx_code="{ item }">
          <v-row class="d-flex flex-row align-start pa-3">
            <v-col cols="12" sm="6" class="d-flex flex-column align-start justify-start" :class="{'px-0 pb-0': isMobile}">
              <router-link :to="'/seller/pesanan-saya'" class="font-weight-bold no-line">{{ item.trx_midtrans_invoice }}</router-link>
              <div :class="{'d-flex flex-column mt-2': isMobile}"><strong>Tanggal Pemesanan</strong><span :class="{'pl-2': !isMobile}">{{ formatDateText(item.trx_status_created_datetime, 'DD MMM YYYY HH:mm') }}</span></div>
            </v-col>
            <v-col cols="12" sm="5" class="text-subtitle-2 black-text font-weight-bold px-0" :class="{'mx-5': !isMobile}">
              {{ hideName(item.trx_buyer_user_name) }}
              <span class="d-block text-caption" v-if="item.user_address_city_name">{{ item.user_address_city_name }}, {{ item.user_address_province_name }}</span>
            </v-col>
          </v-row>
        </template>

        <template v-slot:expanded-item="{ headers }">
          <td :colspan="headers.length" class="mb-2" v-if="!loadingDetail">
            <v-row class="mb-1">
              <v-col cols="12" sm="6" class="text-left" :class="{'pb-0': isMobile}">
                <template v-for="(produk, idp) in detailPesanan.trx_detail">
                  <div class="d-flex flex-row align-center" :class="{'mb-4': !isMobile}" :key="idp">
                    <v-img width="80" max-width="80" class="mr-4" :src="(produk.trx_detail_product_image[0]) ? produk.trx_detail_product_image[0] : '/assets/product/default.png'"></v-img>
                    <div class="d-flex flex-column align-start">
                      <div class="font-weight-bold no-line green--text">{{ produk.trx_detail_product_name }}</div>
                      <div class="text-caption">{{ produk.trx_detail_quantity }} barang ({{ produk.trx_detail_product_weight | toKg }}) @ {{ (produk.trx_detail_product_price) | toRupiah }} </div>
                    </div>
                  </div>
                </template>
              </v-col>

              <v-col cols="12" sm="4" class="text-left" :class="{'pl-0': !isMobile}">
                <div class="d-flex flex-column align-start">
                  <div class="text-subtitle-2 font-weight-bold black--text mb-1">Alamat</div>
                  <span class="text-caption">{{ detailPesanan.user_address_subdistrict_name }}, {{ detailPesanan.user_address_city_name }}, {{ detailPesanan.user_address_province_name }} {{ detailPesanan.user_address_zipcode }}</span>
                </div>
              </v-col>

              <v-col cols="12" sm="2" class="text-left pr-0" :class="{'pt-0': isMobile}">
                <div class="d-flex flex-column align-start">
                  <div class="text-subtitle-2 font-weight-bold black--text mb-1">Total Harga</div>
                  <span class="text-subtitle-1 font-weight-bold green--text">{{ detailPesanan.trx_price_grand_total | toRupiah }}</span>
                </div>
              </v-col>
            </v-row>
          </td>

          <td :colspan="headers.length" v-else>
            <div class="d-block text-center pa-4 text-caption">loading...</div>
          </td>
        </template>

        <template v-slot:no-data>
          <div class="d-flex flex-column align-center py-5 px-5">
            <v-img width="100" height="100" max-width="100" class="py-5 my-4" src="/assets/seller/belum-ada-pesanan.svg"></v-img>
            <div class="text-h6 black--text font-weight-bold">Tidak ada data pesanan yang ditampilkan.</div>
            <p class="black--text darken-5">Tetap semangat, rejeki nggak akan pergi<br>asal kamu pantang menyerah.</p>
          </div>
        </template>
      </v-data-table>
    </v-layout>

    <v-pagination v-if="pesananNewPagination.total_page > 1 && listPesanan.length > 0" @input="updatePage" v-model="page" :length="pesananNewPagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus py-2"></v-pagination>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import moment from 'moment'

export default {
  component: { moment },
  props: ['allowedStatus'], 
  data() {
    return {
      loadingDetail: false,
      loadingStatus: false,
      loadingList: false,
      listPesanan: [],
      panel: [0],
      menuDate: false,
      isMobile: false,
      filterOptions: [
        {
          label: 'No. Invoice',
          value: 'invoice'
        },
        {
          label: 'Nama Pembeli',
          value: 'buyer'
        }
      ],
      filter: {
        type: {
          label: 'No. Invoice',
          value: 'invoice'
        },
        search: '',
        filterId: null,
        sortId: null,
        dateRange: null
      },
      selected: [],
      expanded: [],
      headers: [
        {
          text: 'Info Pesanan',
          align: 'start',
          sortable: false,
          value: 'trx_code',
        },
        { text: 'action', value: 'data-table-expand' }
      ],
      page: 1,
      limit: 5,
      sort: {},
      sortBy: '',
      sortDir: '',
      listSort: [
        {
          sortBy: 'product_price',
          sortDir: 'ASC',
          sortLabel: 'Harga Terendah',
        },
        {
          sortBy: 'product_price',
          sortDir: 'DESC',
          sortLabel: 'Harga Tertinggi',
        },
        {
          sortBy: 'product_input_datetime',
          sortDir: 'DESC',
          sortLabel: 'Produk Terbaru',
        },
        {
          sortBy: 'product_sold_count',
          sortDir: 'DESC',
          sortLabel: 'Produk Terlaris',
        },
        {
          sortBy: 'product_view_count',
          sortDir: 'DESC',
          sortLabel: 'Produk Terpopuler',
        },
      ],
      buyerNameFilter: {
        value: '',
        comparison: 'like',
        type: 'string',
        field: 'trx_buyer_user_name'
      },
      invoiceNoFilter: {
        value: '',
        comparison: 'like',
        type: 'string',
        field: 'trx_midtrans_invoice',
      },
      tglTransaksiFilter: {
        value: '',
        comparison: 'like',
        type: 'string',
        field: 'trx_status_created_datetime',
      },
      statusFilter: {
        value: '',
        comparison: 'yes',
        type: 'list',
        field: 'trx_status',
      },
    }
  },

  computed: {
    ...mapState('transaksiSeller', ['pesananNewData', 'pesananNewPagination', 'detailPesanan']),
    dateRangeText: {
      get(){
        let dates = (this.filter.dateRange) ? new Date(this.filter.dateRange) : null
        return (dates) ? moment(dates).format('DD MMM YYYY') : null
      },
      set(){
        let dates = (this.filter.dateRange) ? new Date(this.filter.dateRange) : null
        return (dates) ? moment(dates).format('DD MMM YYYY') : null
      } 
    }
  },

  async mounted() {
    await this.getListPesanan()
  },

  methods: {
    ...mapActions('transaksiSeller', ['getNewPesanan', 'getPesananDetail', 'getPesananSearch']),

    async getListPesanan() {
      this.loadingList = await true
      let params = await [
      {
        value: 'midtrans::bank_transfer',
        comparison: 'list',
        type: '::',
        field: 'trx_payment_method',
      }
      ]
      let status = ''

      for(let i=0; i<this.allowedStatus.length; i++) {
        status += (i < (this.allowedStatus.length-1)) ? this.allowedStatus[i] + '::' : this.allowedStatus[i]
      }
      this.statusFilter.value = await status
      if (this.statusFilter.value) params.push(this.statusFilter)

      this.page = await 1
      await this.getNewPesanan(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: params
        })
      ).then(async () => {
        this.listPesanan = await this.pesananNewData
        // this.listPesanan = await this.filterAllowedStatus(this.pesananNewData)
        this.loadingList = false
      }).catch(() => {
        this.loadingList = true
      })
    },

    filterAllowedStatus(data) {
      let showList = data.filter(d => this.allowedStatus.includes(d.trx_status))
      return showList
    },

    formatDateText(params, format) {
      let dates = (params) ? new Date(params) : null
      return (dates) ? moment(dates).format(format) : null
    },

    async clearDate() {
      this.filter.dateRange = await null
      this.tglTransaksiFilter.value = await this.filter.dateRange
      this.searchTrx()
    },

    async loadDetailPesanan({item}) {
      this.loadingDetail = await true
      const params = await {
        id: item.trx_id
      }
      await this.getPesananDetail(params)
      this.loadingDetail = false
    },

    setSlugProduct(id, nama) {
      return id + '-' + (nama.toLowerCase()).replace(/ /g, '-')
    },

    async searchTrx() {
      this.loadingList = await true
      let params = await []
      if (this.filter.type.value === 'buyer') {
        if (this.buyerNameFilter.value) await params.push(this.buyerNameFilter)
      } else {
        if (this.invoiceNoFilter.value) await params.push(this.invoiceNoFilter)
      }
      if (this.tglTransaksiFilter.value) await params.push(this.tglTransaksiFilter)
      if (this.statusFilter.value) await params.push(this.statusFilter)

      this.page = await 1
      await this.getNewPesanan(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: params
        })
      ).then(async () => {
        this.listPesanan = await this.filterAllowedStatus(this.pesananNewData)
        this.loadingList = false
      }).catch(() => {
        this.loadingList = false
      })
    },

    async clearSearch() {
      this.filter.search = await ''
      this.filter.type = await {
        label: 'No. Invoice',
        value: 'invoice'
      }
      this.buyerNameFilter.value = await ''
      this.invoiceNoFilter.value = await ''
      this.searchTrx()
    },

    async updatePage(val) {
      this.loadingList = await true
      let params = await []
      let status = ''

      for(let i=0; i<this.allowedStatus.length; i++) {
        status += (i < (this.allowedStatus.length-1)) ? this.allowedStatus[i] + '::' : this.allowedStatus[i]
      }
      this.statusFilter.value = await status
      if (this.statusFilter.value) params.push(this.statusFilter)

      await this.getNewPesanan(
        this.queryString({limit : 5, page : val, params: params})
      ).then(async () => {
        this.listPesanan = await this.pesananNewData
        // this.listPesanan = await this.filterAllowedStatus(this.pesananNewData)
        this.loadingList = false
      }).catch(() => {
        this.loadingList = false
      })
    },
    
    hideName(nama) {
      let enkrip = ''
      for(let i=0; i < nama.length -2; i++) {
        enkrip = enkrip + '*'
      }

      return nama.substr(0, 1) + enkrip + nama.substr(nama.length-1, 1) 
    },

    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
  }
}
</script>

<style lang="scss" scoped>
  .v-spacer {
    width: 1px;
    height: 30px;;
    background: transparent;
    display: block;
    position: relative;
    margin: 0 auto;
    border-left: 3px dotted #ccc;
  }
</style>